var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportmanageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_2269)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6264 3.79492C26.3786 3.79492 26.992 4.4084 26.992 5.1606V32.5795C26.992 33.3318 26.3786 33.9452 25.6264 33.9452H2.67825C1.92598 33.9452 1.3125 33.3317 1.3125 32.5795V5.1606C1.3125 4.4084 1.92591 3.79492 2.67825 3.79492H25.6264Z",
    fill: "#DA8C36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53809 6.01953V31.7191H21.4984L24.767 28.4506V6.01953H3.53809Z",
    fill: "#EFF4F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.498 31.7196L24.7666 28.4512H21.498V31.7196Z",
    fill: "#E2E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62988 3.79445H12.8497L11.4875 1.86845C11.1813 1.43553 11.4896 0.839844 12.0199 0.839844H16.2852C16.8155 0.839844 17.1238 1.43553 16.8176 1.86852L15.4555 3.79452H18.6752C18.9705 3.79452 19.2113 4.03534 19.2113 4.33058V6.35973C19.2113 6.65504 18.9705 6.89586 18.6752 6.89586H9.62988C9.33464 6.89586 9.09375 6.65504 9.09375 6.35973V4.33058C9.09375 4.03527 9.33457 3.79445 9.62988 3.79445Z",
    fill: "#8D9CA8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6394 11.5144C18.95 11.5144 19.2019 11.7662 19.2019 12.0769C19.2019 12.3875 18.95 12.6394 18.6394 12.6394H13.0996C12.789 12.6394 12.5371 12.3875 12.5371 12.0769C12.5371 11.7662 12.789 11.5144 13.0996 11.5144H18.6394ZM21.4237 9.17383C21.7343 9.17383 21.9862 9.42569 21.9862 9.73633C21.9862 10.047 21.7343 10.2988 21.4237 10.2988H13.0996C12.789 10.2988 12.5371 10.047 12.5371 9.73633C12.5371 9.42569 12.789 9.17383 13.0996 9.17383H21.4237Z",
    fill: "#8D9CA8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93128 9.3939C10.1497 9.17424 10.5049 9.17326 10.7245 9.39172C10.9441 9.61018 10.9451 9.96533 10.7267 10.1849L8.51343 12.4189C8.29645 12.6371 7.9446 12.6395 7.72467 12.4254L6.49012 11.222C6.26807 11.006 6.26315 10.6509 6.47915 10.4288C6.69515 10.2068 7.0503 10.2019 7.27235 10.4179L8.10892 11.2333L9.93128 9.3939Z",
    fill: "#64B5F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05859 24.7754H7.9448C8.17718 24.7754 8.36667 24.9649 8.36667 25.1973V29.1089C8.36667 29.3413 8.17718 29.5308 7.9448 29.5308H6.05859C5.82621 29.5308 5.63672 29.3413 5.63672 29.1089V25.1973C5.63672 24.965 5.82628 24.7754 6.05859 24.7754Z",
    fill: "#FC685B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8262 19.5059H12.7124C12.9448 19.5059 13.1342 19.6954 13.1342 19.9277V29.1092C13.1342 29.3416 12.9448 29.5311 12.7124 29.5311H10.8262C10.5938 29.5311 10.4043 29.3416 10.4043 29.1092V19.9277C10.4043 19.6954 10.5939 19.5059 10.8262 19.5059Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5928 21.7715H17.479C17.7114 21.7715 17.9009 21.961 17.9009 22.1934V29.1085C17.9009 29.3409 17.7114 29.5304 17.479 29.5304H15.5928C15.3604 29.5304 15.1709 29.3409 15.1709 29.1085V22.1934C15.1709 21.961 15.3604 21.7715 15.5928 21.7715Z",
    fill: "#72D561"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3604 17.3711H22.2466C22.4789 17.3711 22.6684 17.5606 22.6684 17.793V29.1096C22.6684 29.342 22.4789 29.5315 22.2466 29.5315H20.3604C20.128 29.5315 19.9385 29.342 19.9385 29.1096V17.7929C19.9385 17.5606 20.128 17.3711 20.3604 17.3711Z",
    fill: "#64B5F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44513 21.8428C7.25585 22.0879 6.90365 22.1332 6.65847 21.9439C6.41336 21.7546 6.36808 21.4023 6.55743 21.1572L11.3247 14.959C11.5088 14.7207 11.8468 14.6713 12.0907 14.8427L16.4799 17.7841L20.0736 14.466L19.4719 14.4377C19.1624 14.4231 18.9234 14.1604 18.9379 13.851C18.9525 13.5415 19.2152 13.3025 19.5246 13.317L21.5342 13.4117C21.8437 13.4262 22.0827 13.6889 22.0682 13.9984C22.0665 14.0331 22.0618 14.0669 22.0542 14.0995L21.6998 16.0504C21.6452 16.355 21.354 16.5576 21.0494 16.503C20.7448 16.4484 20.5422 16.1572 20.5967 15.8526L20.6713 15.4422L16.9159 18.9095L16.9154 18.909C16.7293 19.0806 16.4434 19.1092 16.2238 18.9622L11.8928 16.0599L7.44513 21.8428Z",
    fill: "#B4D2D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0824 20.8262H28.5436V22.0611C29.3585 22.2236 30.1163 22.5442 30.7837 22.9896L31.6574 22.116L33.3977 23.8564L32.5241 24.73C32.9696 25.3974 33.29 26.1552 33.4525 26.9701H34.6874V29.4313H33.4525C33.29 30.2462 32.9694 31.004 32.5241 31.6715L33.3977 32.5451L31.6573 34.2854L30.7838 33.4118C30.1164 33.8573 29.3585 34.1777 28.5436 34.3403V35.5752H26.0824V34.3404C25.2675 34.178 24.5097 33.8573 23.8422 33.4119L22.9686 34.2855L21.2282 32.5451L22.1018 31.6715C21.6563 31.0041 21.3359 30.2462 21.1733 29.4313H19.9385V26.9701H21.1734C21.3358 26.1552 21.6564 25.3974 22.1019 24.7299L21.2282 23.8563L22.9686 22.1159L23.8422 22.9895C24.5096 22.5441 25.2675 22.2236 26.0824 22.0611V20.8262Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9193 31.9875C30.0096 31.6487 31.4295 29.6794 31.0906 27.589C30.7518 25.4987 28.7825 24.0788 26.6921 24.4177C24.6018 24.7565 23.1819 26.7258 23.5208 28.8162C23.8597 30.9065 25.8289 32.3264 27.9193 31.9875Z",
    fill: "#EFF4F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_2269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.207031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportmanageIcon);
export default __webpack_public_path__ + "static/media/reportmanage_icon.3e20b684b33487b199104980b0cb7a86.svg";
export { ForwardRef as ReactComponent };